
import React, { useEffect, useState } from 'react';
import { API_BASE, authHeaders } from '../utils/api';
import './LoginLogs.css';

const LoginLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({
    status: '',
    email: '',
    date_from: '',
    date_to: '',
  });

  const fetchLogs = async () => {
    setLoading(true);
    setError('');
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    try {
      const res = await fetch(
        `${API_BASE}/api/admin/login-logs?${params.toString()}`,
        {
          headers: authHeaders(),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || 'Failed to fetch logs');
      }
      setLogs(data.logs || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = (e) => {
    e.preventDefault();
    fetchLogs();
  };

  return (
    <div className="loginlogs-page">
      <div className="page-heading">
        <h1>Login Logs</h1>
        <p>Audit trail of admin access attempts with IP & device context.</p>
      </div>

      {error && <div className="admin-alert error">{error}</div>}

      <form className="filters" onSubmit={handleApplyFilters}>
        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
        >
          <option value="">All statuses</option>
          <option value="SUCCESS">Success</option>
          <option value="FAILED">Failed</option>
        </select>
        <input
          type="text"
          name="email"
          placeholder="Email or IP"
          value={filters.email}
          onChange={handleFilterChange}
        />
        <input
          type="date"
          name="date_from"
          value={filters.date_from}
          onChange={handleFilterChange}
        />
        <input
          type="date"
          name="date_to"
          value={filters.date_to}
          onChange={handleFilterChange}
        />
        <button type="submit">Apply</button>
      </form>

      {loading ? (
        <p>Loading logs…</p>
      ) : (
        <div className="log-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>User</th>
                <th>IP</th>
                <th>Status</th>
                <th>Message</th>
                <th>User Agent</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && (
                <tr>
                  <td colSpan="6">No logs for the selected filters.</td>
                </tr>
              )}
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{new Date(log.login_at).toLocaleString()}</td>
                  <td>
                    {log.user_email || log.email_attempt || 'Unknown'}{' '}
                    {log.role ? `(${log.role})` : ''}
                  </td>
                  <td>{log.ip_address}</td>
                  <td>
                    <span
                      className={
                        log.status === 'SUCCESS' ? 'status active' : 'status'
                      }
                    >
                      {log.status}
                    </span>
                  </td>
                  <td>{log.message}</td>
                  <td className="ua-cell">{log.user_agent || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LoginLogs;



